import { type NodeV2 } from '@vedalib/editor'
import cn from 'classnames'
import React from 'react'

import AbsolutePortal from 'components/Editor/components/AbsolutePortal'
import { ABSOLUTE_PORTAL_GAP } from 'components/Editor/components/AbsolutePortal/constants'
import { KitSize } from 'components/uiKit/KitTypes'
import { Typography } from 'components/uiKit/Typography'
import { useProjectContext } from 'services/Store/Project/hooks'
import { getNodeStyle } from 'services/Store/Project/selectors'
import type { Block, IBlockMode } from 'services/Store/Project/types'

import { getNodeLabel } from '../../getNodeLabel'
import * as s from './NodeV2Label.module.scss'

interface INodeV2HighlightLabelProps {
  mode: IBlockMode
  block: Block
  parent: NodeV2 | null
  node: NodeV2
}

const NodeV2HighlightLabel: React.FC<INodeV2HighlightLabelProps> = ({ block, node, parent }) => {
  const styles = useProjectContext(getNodeStyle, block.uuid, node.id)
  // const isPro = mode.editorMode === AppMode.pro
  const parentStyles = useProjectContext(getNodeStyle, block.uuid, parent?.id)
  const label = getNodeLabel(block, node, styles)
  // const isShift = useProjectContext(getIsActiveShiftKey)
  // const parents = useProjectContext(getParents, block.uuid, node.id)
  // const parentItems = useMemo(() => {
  //   return parents.map((node) => {
  //     const style = mergeNodeStyle(node.style, mode.deviceMode)
  //     const label = getNodeLabel(block, node, style)

  //     const icon = node.elementId ? (
  //       <img className={s.icon} src={ELEMENTS_CONFIG[block.elements[node.elementId].type].icon} />
  //     ) : (
  //       <Icon className={s.icon} name={NODES_ICON_MAP[style.display || 'flex']} size={12} />
  //     )
  //     return { id: node.id, node, style, label, icon }
  //   })
  // }, [block, mode.deviceMode, parents])

  return (
    <AbsolutePortal
      chain='off'
      name='title'
      offset={`${-ABSOLUTE_PORTAL_GAP}px 0`}
      placement='topLeft'
      recalculatingKey={block}
      translateY='-100%'
    >
      <div className={s.root}>
        {/* {isShift &&
          isPro &&
          parentItems.map((item) => (
            <div className={cn(s.item, s.active, s[item.style.display || 'element'])} key={item.id}>
              {item.icon}
              <Typography color='inherit' indents={{ padding: '0 2px' }} rows={1} size={KitSize.S}>
                {item.label}
              </Typography>
            </div>
          ))} */}
        <div className={cn(s.item, s[styles?.display || parentStyles?.display || 'element'])}>
          <Typography color='inherit' indents={{ padding: '0 2px' }} rows={1} size={KitSize.S}>
            {label}
          </Typography>
        </div>
      </div>
    </AbsolutePortal>
  )
}

export default React.memo(NodeV2HighlightLabel)
